import { useEffect } from 'react'
import { useAgentStore } from '../context/AgentProvider'
import { useChats, UseChatsParams } from './useChats'

export const useChatBootstrap = (params?: UseChatsParams) => {
  const chatsQuery = useChats(params)
  const hydrateChats = useAgentStore((state) => state.hydrateChats)

  useEffect(() => {
    if (chatsQuery.data?.pages) {
      const allChats = chatsQuery.data.pages.flatMap((p) => p.data)
      hydrateChats(allChats)
    }
  }, [chatsQuery.data, hydrateChats])

  return chatsQuery
}
